export const SKILL_TYPES = {
  TECHNICAL: 'Technical',
  SOFT: 'Soft'
};

export const getStatusColor = (type) => {
  switch (type) {
    case SKILL_TYPES.TECHNICAL:
      return '#E8F0FE'; // Light blue (same as JOINING)
    case SKILL_TYPES.SOFT:
      return '#E6F4EA'; // Light green (same as EMPLOYED)
    default:
      return '#F3F4F6'; // Light gray (same as RESIGNED)
  }
};

export const getStatusTextColor = (type) => {
  switch (type) {
    case SKILL_TYPES.TECHNICAL:
      return '#1967D2'; // Blue (same as JOINING)
    case SKILL_TYPES.SOFT:
      return '#1E8E3E'; // Green (same as EMPLOYED)
    default:
      return '#6B7280'; // Gray (same as RESIGNED)
  }
};

export const getStatusBorderColor = (type) => {
  switch (type) {
    case SKILL_TYPES.TECHNICAL:
      return '#1967D2'; // Blue (same as JOINING)
    case SKILL_TYPES.SOFT:
      return '#1E8E3E'; // Green (same as EMPLOYED)
    default:
      return '#e2e8f0'; // Light gray
  }
};

export const getStatusHoverColor = (type) => {
  switch (type) {
    case SKILL_TYPES.TECHNICAL:
      return '#D3E3FC'; // Slightly darker light blue
    case SKILL_TYPES.SOFT:
      return '#D5EBD9'; // Slightly darker light green
    default:
      return '#f1f5f9'; // Slightly darker light gray
  }
};

export const getStatusText = (type) => {
  return type.charAt(0).toUpperCase() + type.slice(1);
}; 